<div class="lift-chart-container">
	<div class="campaign_names" *ngIf="campaignsList.length > 1 && campaignCarouselItem">
		<div class="campaign-header-name {{ sectionclass }}">
			<div class="left-arrow">
				<a class="u-opacity-50p lift-icon">
					<span class="next" (click)="prevArrow()" class="carousel-arrow-style">
						<i class="fa fa-angle-left" aria-hidden="true"></i>
					</span>
				</a>
			</div>
			<div class="lift-title ellipsis">
				<span
					appTooltip
					title="{{ campaignCarouselItem.campaign_name }}"
					class="full-text"
					[title]="campaignCarouselItem"
					data-size="small"
					[options]="tooltipOptions"
					>{{ campaignCarouselItem.campaign_name }}</span
				>
			</div>
			<div class="right-arrow">
				<a class="u-opacity-50p lift-icon">
					<span class="prev" (click)="nextArrow()" class="carousel-arrow-style">
						<i class="fa fa-angle-right" aria-hidden="true"></i>
					</span>
				</a>
			</div>
		</div>
	</div>

	<div class="campaign_names" *ngIf="campaignsList.length === 1 && campaignCarouselItem">
		<div class="campaign-header-name {{ sectionclass }}">
			<div class="left-arrow"></div>
			<div class="lift-title ellipsis">
				<span>{{ campaignCarouselItem.campaign_name }}</span>
			</div>
			<div class="right-arrow"></div>
		</div>
	</div>

	<div class="row">
		<app-loader [showLoader]="showLoad || showLoad1"></app-loader>
		<div class="column">
			<div class="c-portlet o-block stats-container-lift">
				<div *ngIf="hasLiftData" class="set_background_color">
					<div class="analytics-portlet-content lift_quick_stats_portlet_content stats_content">
						<div class="lift_stats_subtitle">
							People who saw your digital ads are <br />
							<b>
								<span *ngIf="liftStatsData" class="majorText">{{ liftStatsData.digitalLift }}x more likely</span>
							</b>
							to visit your website.
						</div>
					</div>
					<div class="no-data-container" *ngIf="!hasData1">
						<div class="map-no-data no-data-text">No Data to Display</div>
					</div>
				</div>
			</div>
		</div>

		<div class="column">
			<div
				class="charts-container product-lift-chart-container"
				*ngIf="campaignCarouselItem && hasData"
				[id]="'campaign' + campaignCarouselItem.campaign_id"
			>
				<app-generic-chart
					*ngIf="graphData?.length"
					[configuration]="chartConfig"
					[data]="graphData"
				></app-generic-chart>
			</div>
		</div>
		<div class="no-data-container" *ngIf="!hasData || !hasData1">
			<div class="u-px-small no_lift_data_block stats_content no-data-text">
				<div class="lift_stats_subhead">Campaigns in the selected date range are not eligible for lift reporting.</div>
				<div class="lift_stats_sub_section">
					<div>A campaign must meet all of the following 3 requirements to receive lift reporting:</div>
					<div class="list_items">
						<ol>
							<li>Campaign must have the pixel placed and firing on the website</li>
							<li>Campaign must run for 3 consecutive months</li>
							<li>Campaign must run at least 50,000 audience extension impressions per month</li>
						</ol>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
